import { render, staticRenderFns } from "./CadastrarEditarLotacaoDialog.vue?vue&type=template&id=dad8638c"
import script from "./CadastrarEditarLotacaoDialog.vue?vue&type=script&lang=js"
export * from "./CadastrarEditarLotacaoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports